const QuestionGetter = {
  questions: (state) => state.questions
};

export default QuestionGetter;
